/* eslint-disable no-unused-vars, no-console */
import commonHelper from '@das/canvas-common/src/helper';
import get from 'lodash/get';

/**
 * returns true if action is allowed on the given object(folder/page/component) else false
 * @param {object} params - object containing params
 * @param {boolean} params.atLeastOne - set true to check if at least one component edit is allowed
 * @param {boolean} params.read - set true to check read permissions
 * @param {boolean} params.edit - set true to check edit permissions
 * @param {object} params.component - component object
 * @param {object} params.folder - folder object
 * @param {object} params.report - name of the report
 * @param {object} params.permissions - Object containing allowed permissions
 * @returns {boolean} true if action is allowed on the given object(folder/page/component)
 * else false
 */
const can = function can({ atLeastOne, read, edit, component, folder, report, permissions }) {
  // set action
  const action = read ? 'read' : 'edit';

  // if read for component and folder the return true
  if (read && (component || folder)) {
    return true;
  }

  // can edit/read a component
  if (atLeastOne && component) {
    return get(permissions, ['components', action], []).length > 0;
  }

  // can edit/read a folder
  if (atLeastOne && folder) {
    return get(permissions, ['folders', action], []).length > 0;
  }

  // can edit/read a report
  if (atLeastOne && report) {
    return get(permissions, ['reports', action], []).length > 0;
  }

  if (folder) {
    const Breadcrumb = (folder.Breadcrumb || []).map(b => b.Id);
    return commonHelper.isFolderPermitted({
      permissions,
      action,
      folder: { ...folder, Breadcrumb }
    });
  } else if (component) {
    return commonHelper.isComponentPermitted({ permissions, action, component });
  } else if (report) {
    return commonHelper.isReportPermitted({ permissions, action, reportName: report });
  }
  console.warn(`Access on content type is not identified.`);
  return false;
};

export default { can };
